import { render, staticRenderFns } from "./legalRisk.vue?vue&type=template&id=689ddf49&scoped=true"
import script from "./legalRisk.vue?vue&type=script&lang=js"
export * from "./legalRisk.vue?vue&type=script&lang=js"
import style0 from "./legalRisk.vue?vue&type=style&index=0&id=689ddf49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689ddf49",
  null
  
)

export default component.exports